import { render, staticRenderFns } from "./InvolvedObjectForm.vue?vue&type=template&id=2662ab4a&"
import script from "./InvolvedObjectForm.vue?vue&type=script&lang=js&"
export * from "./InvolvedObjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports